// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type CardBrand } from '@tectonics/prs/card-brand';

export function validateAcceptVisaTerms(accept: boolean, brand: ?CardBrand): ?UserInputValidationError {
  if (brand === 'visa' && !accept) {
    return { id: 'agreement' };
  }
}
